import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'

export function nonEmptyValidator (): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const bad = !control.value?.trim()
    return bad ? { nonEmpty: { value: control.value } } : null
  }
}
